import React, {
    Fragment,
    useEffect,
    useState
} from 'react';
import { User } from 'oidc-client';
import {
    Route,
    Redirect,
    useLocation,
    useHistory
} from 'react-router-dom';

import AuthService from '../services/authService';
import ErrorBoundary from '../components/errors/errorBoundary';
import { publicRoutes } from './appRouteList';

interface AuthenticatedRouteProps {
    component: any;
    // key is required to force the initial state to reset with each route change
    key: string;
    [propName: string]: {};
}

const AuthenticatedRoute: React.FunctionComponent<AuthenticatedRouteProps> = ({ component: Component, ...rest }): JSX.Element => {
    const location = useLocation();
    const history = useHistory();

    const [user, setUser] = useState<User | null>(null);
    const [recievedUserData, setRecievedUserData] = useState(false);

    useEffect((): void => {
        (async (): Promise<void> => {
            try {
                const authenticatedUser = await AuthService.getUser();
                if (authenticatedUser !== null) {
                    setUser(authenticatedUser);
                } else {
                    history.push(publicRoutes.notAuthorized);
                }
            } finally {
                setRecievedUserData(true);
            }
        })();
    }, [Component, history]);

    if (recievedUserData === true && user !== null) {
        return (
            <Route {...rest}>
                <ErrorBoundary>
                    <Component />
                </ErrorBoundary>
            </Route>
        );
    }

    if (recievedUserData === true) {
        return (
            <Redirect
                to={{
                    pathname: publicRoutes.root,
                    state: { from: location }
                }}
            />
        );
    }

    return <Fragment />;
};

export default AuthenticatedRoute;
